module.exports = __webpack_public_path__ + "static/media/Agoria.996e00d6.svg";